import {
  faCircleCheck,
  faLock,
  faPlus,
} from '@fortawesome/pro-solid-svg-icons';
import classNames from 'classnames';
import styled from 'styled-components';

import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';

const Root = styled(Horizontal)`
  width: calc(7 * var(--unit));
  height: calc(7 * var(--unit));
  position: relative;
`;
const SvgContainer = styled.div`
  margin: auto;
  clip-path: url(#shape);

  &.common {
    background: var(--c-gradient-common);
    path {
      fill: var(--c-black);
    }
  }
  &.limited {
    background: var(--c-gradient-limited);
  }
  &.rare {
    background: var(--c-gradient-rare);
  }
  &.super_rare {
    background: var(--c-gradient-superRare);
  }
  &.unique {
    background: var(--c-gradient-unique);
  }
`;
const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
  position: absolute;
  inset: 18px 0 auto 0;
  z-index: 1;
  margin: auto;
`;

type Props = { variant: 'new' | 'locked' | 'completed'; rarity: Rarity };

export const Badge = ({ variant, rarity }: Props) => {
  const icon = { new: faPlus, locked: faLock, completed: faCircleCheck }[
    variant
  ];

  return (
    <Root>
      <StyledFontAwesomeIcon
        icon={icon}
        color={rarity === Rarity.common ? 'var(--c-black)' : 'var(--c-white)'}
      />
      <SvgContainer className={classNames(variant, rarity)}>
        <svg
          width="47"
          height="56"
          viewBox="0 0 47 56"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.4689 2.60728L11.4689 2.60728C19.1051 0.494952 27.1717 0.494952 34.808 2.60728L45.2535 5.4967V39.4439L25.7188 54.977H20.3285L10.9183 47.1535L10.9059 47.1433L10.8933 47.1334L1.02303 39.4379V5.49671L11.4689 2.60728Z"
            fill="white"
            fillOpacity="0"
            stroke="white"
            strokeWidth="2"
            strokeOpacity="0.5"
          />
          <clipPath id="shape">
            <path d="M11.4689 2.60728L11.4689 2.60728C19.1051 0.494952 27.1717 0.494952 34.808 2.60728L45.2535 5.4967V39.4439L25.7188 54.977H20.3285L10.9183 47.1535L10.9059 47.1433L10.8933 47.1334L1.02303 39.4379V5.49671L11.4689 2.60728Z" />
          </clipPath>
        </svg>
      </SvgContainer>
    </Root>
  );
};
